export const calculateDiscountPercentage = (
  basePrice: number,
  sellingPrice: number
) => {
  if (basePrice < 0) {
    throw new Error(`Base price ${basePrice} should be greater than 0`);
  }
  return ((basePrice - sellingPrice) / basePrice) * 100;
}